export default __webpack_public_path__ + "static/media/SAS0200.34I-36003_-21020_0.b47bd66b.jpg";